import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { getSubscription, getCreatorId } from "../lib/api";

const DISMISS_KEY = "otaku_reactivate_dismissed";

// Small, friendly banner shown at the top of the Catalogue when a user's
// Pro Pass subscription has lapsed. One-tap to /support to restart. Can be
// dismissed for this browser session.
export default function ReactivateBanner() {
  const [state, setState] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      if (window.sessionStorage.getItem(DISMISS_KEY) === "1") {
        setDismissed(true);
      }
    } catch (err) { console.warn("sessionStorage read failed:", err); }
    getSubscription(getCreatorId())
      .then((s) => setState(s?.state || null))
      .catch(() => setState(null));
  }, []);

  const dismiss = () => {
    setDismissed(true);
    try { window.sessionStorage.setItem(DISMISS_KEY, "1"); }
    catch (err) { console.warn("sessionStorage write failed:", err); }
  };

  if (dismissed || state !== "expired") return null;

  return (
    <div
      data-testid="reactivate-banner"
      className="mb-8 flex flex-col gap-3 border border-[#FF3B30]/40 bg-[#FF3B30]/5 p-4 md:flex-row md:items-center md:justify-between"
    >
      <div className="flex items-start gap-3">
        <Sparkles className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#FF3B30]" />
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-[#FF3B30]">Welcome back</p>
          <p className="mt-1 text-sm text-neutral-200">
            Your Pro Pass ended. Everything you tracked is still here — restart to unlock Persona, Schedule, Discover, and more.
          </p>
        </div>
      </div>
      <div className="flex flex-shrink-0 items-center gap-2">
        <Link
          to="/premium"
          data-testid="reactivate-banner-cta"
          className="border border-white/20 bg-[#FF3B30] px-4 py-2 font-mono text-[10px] uppercase tracking-widest text-white hover:bg-white hover:text-black"
        >
          Restart Pro Pass
        </Link>
        <button
          data-testid="reactivate-banner-dismiss"
          onClick={dismiss}
          aria-label="Dismiss"
          className="border border-white/15 p-2 text-neutral-400 hover:bg-white hover:text-black"
        >
          <X className="h-3 w-3" />
        </button>
      </div>
    </div>
  );
}
